import Vue from 'vue'
import Vuex from 'vuex'
import EventService from "./services/EventService";
import LoginService from "./services/LoginService";
import axios from 'axios/index'
import ParticipantService from "./services/ParticipantService";
import ProfileService from "./services/ProfileService";
import CheckpointService from "./services/CheckpointService";
import CategoryService from "./services/CategoryService";
import SportabelService from "@/services/SportabelService";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    event: {
      id: 0,
      title: 'Sportabel.de Testevent',
      description: 'Dieses Event ist nur ein Platzhalter.',
      startDate: '0000-00-00',
      endDate: '0000-00-00',
      registrationStart: '0000-00-00',
      registrationEnd: '0000-00-00',
      logo: '',
      image: '',
      announcement: 'http://www.sportabel.de',
      token: 'grimmsteigtage24',
      participants: 999
    },
    categories: [],
    checkpoints: [],
    participants: [],
    token: localStorage.getItem('token') || '',
    user : {
      id: 0,
      username: '',
      firstname: '',
      lastname: '',
      email: '',
      password: ''
    },
    participantPagination: {},
    participantSearch: null,
    participantFilter: null,
    loader: false,
    sportabelEvents: []
  },
  mutations: {
    LOAD_EVENT(state, data) {
      state.event = data
    },
    LOAD_EVENT_CATEGORIES(state, data) {
      state.categories = data
    },
    LOAD_EVENT_PARTICIPANTS(state, data) {
      state.participants = data
    },
    SET_PARTICIPANT(state, participant) {
      Vue.set(
          state.participants,
          state.participants.findIndex(item => item.id === participant.id),
          participant
      )
    },
    ADD_PARTICIPANT(state, participant) {
      Vue.set(state.participants, state.participants.length, participant)
    },
    auth_success(state, token){
      state.token = token
    },
    logout(state){
      state.token = ''
    },
    LOADER(state, status){
      state.loader = status
    },
    SET_USER(state, user) {
      state.user = user
    },
    SET_PARTICIPANT_PAGINATION (state, payload) {
      state.participantPagination = payload
    },
    SET_PARTICIPANT_SEARCH (state, payload) {
      state.participantSearch = payload
    },
    SET_PARTICIPANT_FILTER (state, payload) {
      state.participantFilter = payload
    },
    LOAD_CHECKPOINTS(state, data) {
      state.checkpoints = data
    },
    SET_CHECKPOINT(state, checkpoint) {
      Vue.set(
          state.checkpoints,
          state.checkpoints.findIndex(item => item.id === checkpoint.id),
          checkpoint
      )
    },
    ADD_CHECKPOINT(state, checkpoint) {
      Vue.set(state.checkpoints, state.checkpoints.length, checkpoint)
    },
    SET_CATEGORY(state, category) {
      Vue.set(
          state.categories,
          state.categories.findIndex(item => item.id === category.id),
          category
      )
    },
    SET_SPORTABEL_EVENTS(state, events) {
      state.sportabelEvents = events
    }
  },
  actions: {
    reloadData() {
      this.dispatch('loadEvent', this.state.event.token)
    },
    setParticipantPagination({commit}, pagination) {
      commit('SET_PARTICIPANT_PAGINATION', pagination)
    },
    setParticipantSearch({commit}, pagination) {
      commit('SET_PARTICIPANT_SEARCH', pagination)
    },
    setParticipantFilter({commit}, pagination) {
      commit('SET_PARTICIPANT_FILTER', pagination)
    },
    loadProfile({commit}) {
      ProfileService.load().then(response => {
        commit('SET_USER', response.data)
      }).catch(() => {
        this.dispatch('logout')
      })
    },
    updateProfile({commit}) {
      return ProfileService.update(this.state.user).then(response => {
        commit('SET_USER', response.data)
      })
    },
    loadEvent({commit}, token) {
      EventService.getEvent(token).then(data => {
        commit('LOAD_EVENT', data)
        EventService.getEventCategories(token).then(data => {
          commit('LOAD_EVENT_CATEGORIES', data)
        })
        EventService.getEventParticipants(token).then(data => {
          commit('LOAD_EVENT_PARTICIPANTS', data)
        })
        CheckpointService.getAllByEvent(token).then(response => {
          commit('LOAD_CHECKPOINTS', response.data)
        })
      })
    },
    loadParticipants({commit}, token) {
      EventService.getEventParticipants(token).then(data => {
        commit('LOAD_EVENT_PARTICIPANTS', data)
      })
    },
    loadParticipant({commit}, participant) {
      return ParticipantService.get(participant).then(response => {
        commit('SET_PARTICIPANT', response.data)
      })
    },
    addParticipant({commit}, participant) {
      return ParticipantService.add(participant).then(response => {
        commit('ADD_PARTICIPANT', response.data)
        return response.data.id
      })
    },
    saveParticipant({commit}, participant) {
      return ParticipantService.save(participant).then(response => {
        commit('SET_PARTICIPANT', response.data)
        return response
      })
    },
    login({commit}, user){
      return new Promise((resolve, reject) => {
        LoginService.login(user)
            .then(resp => {
              const token = resp.data.token
              localStorage.setItem('token', token)
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
              commit('auth_success', token)
              // @TODO Replace token
              this.dispatch('loadEvent', localStorage.getItem('event'))
              resolve(resp)
            })
            .catch(err => {
              localStorage.removeItem('token')
              reject(err)
            })
      })
    },
    logout({commit}){
      return new Promise((resolve) => {
        commit('logout')
        localStorage.removeItem('token')
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    },
    setLoader({commit}, status){
      commit('LOADER', status)
    },
    loadCheckpoints({commit}, token) {
      CheckpointService.getAllByEvent(token).then(response => {
        commit('LOAD_CHECKPOINTS', response.data)
      })
    },
    updateCheckpoint({commit}, checkpoint) {
      if (checkpoint.id === 0) {
        return CheckpointService.add(checkpoint).then(response => {
          commit('ADD_CHECKPOINT', response.data)
          return response.data.id
        })
      } else {
        CheckpointService.save(checkpoint).then(response => {
          commit('SET_CHECKPOINT', response.data)
          return response
        })
      }
    },
    // eslint-disable-next-line no-unused-vars
    deleteCheckpoint({commit}, checkpoint) {
      return CheckpointService.delete(checkpoint).then(() => {
        this.dispatch('loadCheckpoints', this.state.event.token)
        this.dispatch('loadCategories', this.state.event.token)
      })
    },
    updateCategory({commit}, category) {
        CategoryService.save(category).then(response => {
          commit('SET_CATEGORY', response.data)
          this.dispatch('loadCheckpoints', this.state.event.token)
          this.dispatch('loadCategories', this.state.event.token)
          this.dispatch('loadParticipants', this.state.event.token)
          return response
        })
    },
    loadCategories({commit}, token) {
      EventService.getEventCategories(token).then(data => {
        commit('LOAD_EVENT_CATEGORIES', data)
      })
    },
    loadSportabelEvents({commit}) {
      return SportabelService.loadEvents().then(response => {
        commit('SET_SPORTABEL_EVENTS', response.data)
      })
    },
  },
  getters : {
    isLoggedIn: state => !!state.token,
    participantPagination: state => state.participantPagination,
    participantSearch: state => state.participantSearch,
    participantFilter: state => state.participantFilter
  }
})
